import $ from 'jquery';

$(".impersonate").click(function() {
    var url = $(this).prop('href');
    var data = {_token:$(this).parent().parent().attr('data-token'), user:$(this).attr('data-user')};
    if($(this).attr('data-redirect-url')) {
        data.redirect_url = $(this).attr('data-redirect-url');
    }

    $.ajax({
        type: "POST",
        url: url,
        data: data,
        error: function(data) {
            displayErrorGritter(data.responseJSON);
        },
        success: function(data) {
            window.location = data.redirect;
        }
    });

    return false;
});
